import { map } from "lodash";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  Autocomplete,
  Button,
} from "@mui/material";
import { Field, Formik, Form, useFormikContext } from "formik";
import * as Yup from "yup";
import { format } from "date-fns";

import useAuth from "./../../hooks/useAuth";

const CustomerSelect = () => {
  const { customers } = useSelector((state) => state.customers);
  const { values, setFieldValue, touched, errors } = useFormikContext();
  const getOptions = React.useMemo(
    () =>
      map(customers, (customer, id) => {
        return {
          label: customer.name,
          id,
        };
      }),
    [customers]
  );
  return (
    <Autocomplete
      autoSelect
      fullWidth
      onChange={(e, v) => {
        setFieldValue("customer", v?.id);
      }}
      options={getOptions}
      renderInput={(params) => (
        <TextField
          sx={{ mt: 4 }}
          {...params}
          helperText={touched.customer && errors.customer}
          error={touched.customer && !!errors.customer}
          label="Customer"
        />
      )}
    />
  );
};

const WODialog = ({ open, onClose }) => {
  const { user } = useAuth();
  const validationSchema = React.useCallback(
    () =>
      Yup.object({
        wo: Yup.string().required(),
        customer: Yup.string().required(),
        coordinator: Yup.string().required(),
        date: Yup.string().required(),
      }),
    []
  );
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Add Work Order</DialogTitle>
      <DialogContent>
        <Formik
          initialValues={{
            wo: "",
            customer: "",
            coordinator: `${user?.firstName} ${user?.lastName}`,
            date: format(new Date(), "yyyy-MM-dd"),
            summary: "",
            status: "CREATED",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            console.log(values);
          }}
        >
          {({ values, errors, handleChange, touched }) => {
            return (
              <Form>
                <Field
                  as={TextField}
                  sx={{ mt: 4 }}
                  name="wo"
                  label="Work Order"
                  variant="outlined"
                  fullWidth
                  helperText={touched.wo && errors.wo}
                  error={touched.wo && !!errors.wo}
                  margin="normal"
                />
                <CustomerSelect />
                <Field
                  as={TextField}
                  sx={{ mt: 4 }}
                  name="coordinator"
                  label="Coordinator"
                  variant="outlined"
                  fullWidth
                  helperText={touched.coordinator && errors.coordinator}
                  error={touched.coordinator && !!errors.coordinator}
                  margin="normal"
                />
                <Field
                  as={TextField}
                  sx={{ mt: 4 }}
                  name="date"
                  label="Date"
                  variant="outlined"
                  type="date"
                  fullWidth
                  helperText={touched.date && errors.date}
                  error={touched.date && !!errors.date}
                  margin="normal"
                />
                <Field
                  as={TextField}
                  sx={{ mt: 4 }}
                  name="summary"
                  label="Summary"
                  variant="outlined"
                  fullWidth
                  multiline
                  rows={2}
                  margin="normal"
                />
                <DialogActions>
                  <Button type="submit">Add</Button>
                </DialogActions>
              </Form>
            );
          }}
        </Formik>
      </DialogContent>
    </Dialog>
  );
};

export default WODialog;
